/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_mobile_analytics_app_id": "02326c3ad5c9488e8016e6a442b39f4c",
    "aws_mobile_analytics_app_region": "eu-central-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "02326c3ad5c9488e8016e6a442b39f4c",
            "region": "eu-central-1"
        }
    },
    "Notifications": {
        "Email": {
            "AWSPinpoint": {
                "appId": "02326c3ad5c9488e8016e6a442b39f4c",
                "region": "eu-central-1"
            }
        }
    },
    "aws_appsync_graphqlEndpoint": "https://p7xjf6jikvcqrfnb76coi7jhiq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-zhkhnkrcpzeffdqhweztw2j3li",
    "aws_cloud_logic_custom": [
        {
            "name": "nanonetsCallback",
            "endpoint": "https://kbww9kk7kk.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        },
        {
            "name": "viberBotWebhook",
            "endpoint": "https://acu012b3dh.execute-api.eu-central-1.amazonaws.com/dev",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:77f75486-bb6a-4cf3-b0cb-820930e98c4d",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_YEkImRe4a",
    "aws_user_pools_web_client_id": "72oksj5iomu9j86901kojvb9us",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "cf-invoices-storage74835-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
